const promiseData = {}


const Promiser = ( identifier, promise ) => {
    let reject = null ;
    const promiseWrapper = new Promise( ( res, rej ) => {
        reject = rej ;
        promise.then( res ).catch( rej ) ;
    })

    if( !promiseData[ identifier ] ) promiseData[ identifier ] = [] ;

    promiseData[ identifier ].push( reject );

    return promiseWrapper ;

}

Promiser.reject = ( identifier, data = null ) => {
    if( !promiseData[ identifier ] ) return ;
    promiseData[ identifier ].forEach( rej => rej( data ) ) ;
    Promiser.clear( identifier );
}

Promiser.clear = ( identifier ) => {
    promiseData[ identifier ] = [];
}

export default Promiser ;